import axios from "axios";
import { ElNotification } from 'element-plus'
import 'element-plus/dist/index.css'
import qs from 'qs';

//创建axios实例
const service = axios.create({
    // baseURL: 'http://192.168.2.9:8888',
    baseURL: 'https://server.dearzhao.top',
    timeout: 5000,   //超时时间
    withCredentials: true
});

//请求拦截器
service.interceptors.request.use(
    config => {
        //判断是否需要token
        if(config.headers['X-No-Token'] != true){
            // 从localStorage获取Token
            const token = localStorage.getItem('token');
            if(token){
                config.headers['Authorization'] = `Bearer ${token}`;
            } else {
                //跳转登录界面
            }
        }
        return config;
    },
    error => {
        //处理请求错误
        Promise.reject(error);
    }
);

//响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data;
        if(res.code != "ZG20000"){
            //根据业务code处理
            ElNotification({
              title: 'Error',
              message: res.message,
              type: 'error',
              showClose: false,
            })
            return Promise.reject(res.message);
        } else {
            return res;
        }
    },
    error => {
        //处理响应错误
        ElNotification({
          title: 'Error',
          message: error.message,
          type: 'error',
          showClose: false,
        })
        return Promise.reject(error);
    }
);


// 封装POST请求  
service.postZg = (url, data, config = {}) => {  
    let contentType = config.contentType || 'json';  
    if (contentType === 'json') {  
      return service.post(url, data);  
    } else if (contentType === 'x-www-form-urlencoded') {  
      return service.post(url, qs.stringify(data), {  
        headers: {  
          'Content-Type': 'application/x-www-form-urlencoded'  
        }  
      });  
    } else if (contentType === 'form-data') {  
      let formData = new FormData();  
      for (let key in data) {  
        formData.append(key, data[key]);  
      }  
      return service.post(url, formData, {  
        headers: {  
          'Content-Type': 'multipart/form-data'  
        }  
      });  
    }  
  };

export default service;
